import styled from 'styled-components';

export const Wrapper = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  line-height: ${props => (props.isSmall ? '32px' : '40px')};
  padding: 0 ${props => props.theme.space(3)};
  width: auto;
  min-width: 67px;
  height: ${props => (props.isSmall ? '32px' : '40px')};
  overflow: visible;
  font-size: ${props => props.theme.rem(14)};
  font-weight: 500;
  border: none;
  border-radius: 8px;
  -webkit-font-smoothing: inherit;
  -moz-osx-font-smoothing: inherit;
  -webkit-appearance: none;
  appearance: none;
  white-space: nowrap;
  cursor: pointer;
  -webkit-user-select: none;
  -ms-user-select: none;
  user-select: none;
  ${({ theme }) => theme.gap(2)};

  span {
    display: flex;
    align-items: center;
    ${({ theme }) => theme.gap(2)};
  }

  &:disabled {
    opacity: 0.5;
  }

  &::-moz-focus-inner {
    border: 0;
    padding: 0;
  }

  ${props =>
    props.isPrimary &&
    `
    background: ${props.theme.unisystem.button.primary.background};
    color: ${props.theme.unisystem.button.primary.color};

    @media (hover:hover) {
      &:hover {
        background: ${props.theme.unisystem.button.primary.hover};
      }
    }
  `}

  ${props =>
    props.isSecondary &&
    `
    background: ${props.theme.unisystem.button.secondary.background};
    border: 1px solid ${props.theme.unisystem.button.secondary.border};
    color: ${props.theme.unisystem.button.secondary.color};

    @media (hover:hover) {
      &:hover {
        background-color: ${props.theme.unisystem.button.secondary.hover};
      }
    }
  `}

  ${props =>
    props.isTertiary &&
    `
    background: ${props.theme.unisystem.button.tertiary.background};
    border: 1px solid ${props.theme.unisystem.button.tertiary.border};
    color: ${props.theme.unisystem.button.tertiary.color};

    @media (hover:hover) {
      &:hover {
        background: ${props.theme.unisystem.button.tertiary.hover};
      }
    }

    ${props.isSelected} {
      border: 2px solid ${props.theme.unisystem.button.tertiary.selected};
    }
  `}

  ${props =>
    props.isDanger &&
    `
    background: ${props.theme.unisystem.button.danger.background};
    color: ${props.theme.unisystem.button.danger.color};

    @media (hover:hover) {
      &:hover {
        background: ${props.theme.unisystem.button.danger.hover};
      }
    }
  `}

  ${props =>
    props.isGhost &&
    `
    background: ${props.theme.unisystem.button.ghost.background};
    color: ${props.theme.unisystem.button.ghost.color};

    @media (hover:hover) {
      &:hover {
        background: ${props.theme.unisystem.button.ghost.hover};
      }
    }
  `}

  ${props =>
    props.isDisabled &&
    `
    pointer-events: none;
    background: ${props.theme.unisystem.button.disabled.background};
    color: ${props.theme.unisystem.button.disabled.color};
  `};

  ${props =>
    props.isLoading &&
    `
    pointer-events: none;
    opacity: 0.5;
  `};
`;
